// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"2e4dba0144a2cfd7209c","453":"f3345aff713d16979b2d","758":"924d0cd2d5ff47900844"}[chunkId] + ".js";
};